import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<
 HTMLTextAreaElement,
 React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
 return (
 <textarea
 className={cn(
 "flex min-h-[60px] w-full rounded-md border border-border bg-card text-foreground px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:border-accent disabled:bg-surface disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
 className
 )}
 ref={ref}
 {...props}
 />
 )
})
Textarea.displayName = "Textarea"

export { Textarea }
